module.exports = __webpack_public_path__ + "static/img/category_50.bf0bdb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_50.png
// module id = Zh/U
// module chunks = 0